import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';
import { $getRoot, $getSelection, $isRangeSelection } from 'lexical';

export function DefaultBoldFormatPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    const ensureBoldWhenEmpty = () => {
      editor.getEditorState().read(() => {
        const root = $getRoot();
        const selection = $getSelection();
        if (
          root.getTextContentSize() === 0 &&
          $isRangeSelection(selection) &&
          !selection.hasFormat('bold')
        ) {
          editor.update(() => {
            const sel = $getSelection();
            if ($isRangeSelection(sel) && !sel.hasFormat('bold')) {
              sel.formatText('bold');
            }
          });
        }
      });
    };

    ensureBoldWhenEmpty();
    return editor.registerUpdateListener(ensureBoldWhenEmpty);
  }, [editor]);

  return null;
}
